// export const API_URL = 'https://api.goldenpharma.octopharma.net/api';
// export const API_URL = 'https://api.oubari.octopharma.net/api';
// export const API_URL = 'https://mirror-api.octopharma.net/api';
// export const API_URL = 'https://mirta-mirror-api.octopharma.net/api';
export const API_URL = 'https://api.ibn-alhaytham.octopharma.net/api';
// export const API_URL = 'https://alradwan-mirror-api.octopharma.net/api';
// export const API_URL = 'https://api.alradwan.octopharma.net/api';
export const VERSION = '2.7.0';